import classNames from "classnames";
import { FC, HTMLAttributes, ReactNode } from "react";

const ActionCard: FC<{ title: ReactNode; actionIcon: ReactNode; subTitle: ReactNode, onClick:()=>void } & Omit<HTMLAttributes<HTMLDivElement>, "title">> = ({
  title,
  actionIcon,
  subTitle,
  onClick,
  className,
  ...props
}) => {
  return (
    <div className={classNames("flex items-center justify-between", className)} {...props}>
      <div className="flex flex-col gap-0.5">
        <div>{title}</div>
        <div>{subTitle}</div>
      </div>
      <div onClick={onClick} role="button" className="cursor-pointer p-1">{actionIcon}</div>
    </div>
  );
};

export default ActionCard;
